module.exports = __webpack_public_path__ + "assets/img/3_1197.fd961e62.jpg";